// SCR-005's route (NAV-004 price book), composed into the route table by TASK-140.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { Prices } from "./prices";

export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-004", path: "/model-prices", title: "Model prices", permission: "billing:read", component: Prices }),
];
